const CONTROL_PLANE_API = import.meta.env.VITE_CONTROL_PLANE_API || 'http://localhost:3000';

export interface MeResponse {
  authenticated: boolean;
  identity?: { id: string; email?: string; name?: string };
  operator_tenant?: string;
  roles?: string[];
  is_operator?: boolean;
  /** Present only for operators — normal visitors never see this exists. */
  admin_console_url?: string | null;
}

/**
 * Session orientation: who the visitor is and what applies to them. Never
 * throws — an unreachable control plane just means "no extra capabilities".
 */
export async function fetchMe(): Promise<MeResponse> {
  try {
    const response = await fetch(`${CONTROL_PLANE_API}/api/me`, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return { authenticated: false };
    return (await response.json()) as MeResponse;
  } catch {
    return { authenticated: false };
  }
}
